import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=6c9b41f2&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/figma.css?vue&type=style&index=0&id=6c9b41f2&scoped=true&lang=css&"
import style1 from "./Add.vue?vue&type=style&index=1&id=6c9b41f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b41f2",
  null
  
)

export default component.exports